export default "__VITE_ASSET__DvYpTWyM__"